module.exports = __webpack_public_path__ + "3f9b2e951a216ee53633eeed23fe38a6.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/DOW_LOGO_FORUMS.png
// module id = 145
// module chunks = 0